module.exports = __webpack_public_path__ + "img/camera-rotate.e2070d99.svg";